<template>
  <div>
    <div v-if="editing">
      <HtmlEditor @change="change" :value="component.html"></HtmlEditor>
    </div>
    <div v-else>
      <pre class="pre-scrollable"><code>{{component.html}}</code></pre>
    </div>
  </div>
</template>

<script>
import HtmlEditor from './../HtmlEditor'

export default {
  components: {
    HtmlEditor,
  },
  props: ['component', 'editing'],
  data() {
    return {}
  },
  methods: {
    change(html) {
      this.component.html = html
    },
  },
}
</script>
<style></style>
